import type { FooterLinksList } from "@/types/footer";

export enum LinksWithSubMenu {
  TEAMS = "teams",
  COMPETITIONS = "competitions",
}

export const SERVER_ERROR_CODE = 500;
export const OUT_ANIMATION_DURATION = 250 + 650;

export const OFTV_URL = "https://tv.onefootball.com";
export const BETS_PTBR_URL = "https://onefootball.com/pt-br/apostas";

export const BETS_COUNTRY_MAP: Record<string, string> = {
  BR: "pt-br/apostas",
  ES: "es/apuestas",
  PE: "es/apuestas/pe",
  CL: "es/apuestas/cl",
  MX: "es/apuestas/mx",
  CO: "es/apuestas/co",
  UK: "en/betting",
  CA: "en/betting/ca",
  US: "en/betting/us",
  IN: "en/betting/in",
};

export const STATIC_BETTING_LINKS: Record<string, FooterLinksList> = {
  en: [
    { urlPath: "https://onefootball.com/en/betting", name: "Betting UK" },
    { urlPath: "https://onefootball.com/en/betting/us", name: "Betting US" },
    { urlPath: "https://onefootball.com/en/betting/in", name: "Betting India" },
    {
      urlPath: "https://onefootball.com/en/betting/ca",
      name: "Betting Canada",
    },
  ],
  es: [
    { urlPath: "https://onefootball.com/es/apuestas", name: "Apuestas España" },
    {
      urlPath: "https://onefootball.com/es/apuestas/pe",
      name: "Apuestas Peru",
    },
    {
      urlPath: "https://onefootball.com/es/apuestas/cl",
      name: "Apuestas Chile",
    },
    {
      urlPath: "https://onefootball.com/es/apuestas/mx",
      name: "Apuestas México",
    },
    {
      urlPath: "https://onefootball.com/es/apuestas/co",
      name: "Apuestas Colombia",
    },
  ],
  "pt-br": [
    {
      urlPath: "https://onefootball.com/pt-br/apostas",
      name: "Apostas Brasil",
    },
    {
      urlPath: "https://onefootball.com/pt-br/apostas/casas-de-apostas",
      name: "Casas de Apostas",
    },
    {
      urlPath: "https://onefootball.com/pt-br/apostas/palpites",
      name: "Palpites de Apostas",
    },
    {
      urlPath: "https://onefootball.com/pt-br/apostas/cassinos-online",
      name: "Cassinos Online",
    },
  ],
};
